/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelAvailableLoads.ts                *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/powerbroker/available-loads";

export class AutogenModelAvailableLoads<RowType extends ModelRow> extends Endpoint<RowType, RowAvailableLoadsFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowAvailableLoads extends ModelRow<RowAvailableLoadsFields> {
	constructor(values?: Partial<RowAvailableLoadsFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowAvailableLoadsFields {
	brokerage: string;
	"carrier_offer.id": string;
	"commodity.company_id": string;
	"commodity.cubic_units": number;
	"commodity.cubic_units_is_per_piece": string;
	"commodity.descr": string;
	"commodity.dunnage_is_per_piece": string;
	"commodity.dunnage_weight": number;
	"commodity.fgi_value": number;
	"commodity.fgi_value_c": string;
	"commodity.fgi_value_d": Date;
	"commodity.fgi_value_is_per_piece": string;
	"commodity.fgi_value_n": number;
	"commodity.fgi_value_r": number;
	"commodity.handling_units": number;
	"commodity.handling_units_is_per_piece": string;
	"commodity.hazmat": string;
	"commodity.hazmat_class_code": string;
	"commodity.hazmat_contact": string;
	"commodity.hazmat_erg_number": string;
	"commodity.hazmat_is_residue": string;
	"commodity.hazmat_number": string;
	"commodity.hazmat_packing_group": string;
	"commodity.hazmat_phone": string;
	"commodity.hazmat_proper_shipname": string;
	"commodity.hazmat_qty_code": string;
	"commodity.hazmat_ref_type_code": string;
	"commodity.hazmat_subclass_code": string;
	"commodity.height": number;
	"commodity.id": string;
	"commodity.intelliset": string;
	"commodity.is_hazmat": string;
	"commodity.is_poison": string;
	"commodity.length": number;
	"commodity.nmfc_class_code": string;
	"commodity.nmfc_code": string;
	"commodity.optiset": string;
	"commodity.packaging_type_code": string;
	"commodity.placard_required": string;
	"commodity.poison_zone": string;
	"commodity.product_sku": string;
	"commodity.req_spots": number;
	"commodity.return_var": number;
	"commodity.return_var_um": string;
	"commodity.scan_unit_type": string;
	"commodity.seats": number;
	"commodity.seats_is_per_piece": string;
	"commodity.setpoint_temp": number;
	"commodity.setpoint_temp_um": string;
	"commodity.setpoint_var": number;
	"commodity.setpoint_var_um": string;
	"commodity.signoff_text": string;
	"commodity.spots_is_per_piece": string;
	"commodity.temperature_max": number;
	"commodity.temperature_max_um": string;
	"commodity.temperature_min": number;
	"commodity.temperature_min_um": string;
	"commodity.training_url": string;
	"commodity.type_code": string;
	"commodity.weight": number;
	"commodity.weight_is_per_piece": string;
	"commodity.weight_uom_type_code": string;
	"commodity.width": number;
	"customer.activity_count": number;
	"customer.activity_start_date": Date;
	"customer.add_empty_distance_occ": string;
	"customer.add_finance_charge": string;
	"customer.address1": string;
	"customer.address2": string;
	"customer.allow_inc_in_frt": string;
	"customer.auto_rate": string;
	"customer.auto_tax": string;
	"customer.available_template": number;
	"customer.average_bill": number;
	"customer.average_bill_c": string;
	"customer.average_bill_d": Date;
	"customer.average_bill_n": number;
	"customer.average_bill_r": number;
	"customer.average_pay_days": number;
	"customer.balance": number;
	"customer.balance_c": string;
	"customer.balance_d": Date;
	"customer.balance_n": number;
	"customer.balance_r": number;
	"customer.benchmark_ctg_uid": number;
	"customer.benchmark_tar_uid": number;
	"customer.bill_due_days": number;
	"customer.bill_format_flag": string;
	"customer.bill_template": number;
	"customer.bill_transfer_when": string;
	"customer.billed_loads": number;
	"customer.bl_logo": string;
	"customer.bl_logo_name": string;
	"customer.blanket_buy_tariff_id": string;
	"customer.blanket_sell_tariff_id": string;
	"customer.bridge_id": string;
	"customer.brokerage_filter": string;
	"customer.business_hours": string;
	"customer.business_number": string;
	"customer.buy_tariff_id": string;
	"customer.carrier_scorecard_exported": string;
	"customer.category": string;
	"customer.cert_of_ins_date": Date;
	"customer.charge_detention": string;
	"customer.chassis_chargeby": string;
	"customer.chassis_freedays": number;
	"customer.chassis_rate": number;
	"customer.chassis_rate_c": string;
	"customer.chassis_rate_d": Date;
	"customer.chassis_rate_n": number;
	"customer.chassis_rate_r": number;
	"customer.city": string;
	"customer.city_id": number;
	"customer.coll_thresh_pd1": number;
	"customer.coll_thresh_pd1_c": string;
	"customer.coll_thresh_pd1_d": Date;
	"customer.coll_thresh_pd1_n": number;
	"customer.coll_thresh_pd1_r": number;
	"customer.coll_thresh_pd2": number;
	"customer.coll_thresh_pd2_c": string;
	"customer.coll_thresh_pd2_d": Date;
	"customer.coll_thresh_pd2_n": number;
	"customer.coll_thresh_pd2_r": number;
	"customer.coll_thresh_pd3": number;
	"customer.coll_thresh_pd3_c": string;
	"customer.coll_thresh_pd3_d": Date;
	"customer.coll_thresh_pd3_n": number;
	"customer.coll_thresh_pd3_r": number;
	"customer.coll_thresh_pd4": number;
	"customer.coll_thresh_pd4_c": string;
	"customer.coll_thresh_pd4_d": Date;
	"customer.coll_thresh_pd4_n": number;
	"customer.coll_thresh_pd4_r": number;
	"customer.collections_id": string;
	"customer.collections_ok": string;
	"customer.company_id": string;
	"customer.confidence_level": number;
	"customer.container_chargeby": string;
	"customer.container_freedays": number;
	"customer.container_rate": number;
	"customer.container_rate_c": string;
	"customer.container_rate_d": Date;
	"customer.container_rate_n": number;
	"customer.container_rate_r": number;
	"customer.contract_cbc": string;
	"customer.contract_ccc": string;
	"customer.contract_gbc": string;
	"customer.contract_gcc": string;
	"customer.contract_sbc": string;
	"customer.contract_scc": string;
	"customer.controlling_carrier_code": string;
	"customer.conversion_date": Date;
	"customer.cost_ctg_uid": number;
	"customer.cost_tar_uid": number;
	"customer.covered_template": number;
	"customer.cp_logo": string;
	"customer.cp_logo_name": string;
	"customer.credit_application": string;
	"customer.credit_check_date": Date;
	"customer.credit_limit": number;
	"customer.credit_limit_c": string;
	"customer.credit_limit_d": Date;
	"customer.credit_limit_n": number;
	"customer.credit_limit_r": number;
	"customer.credit_status": string;
	"customer.credit_warning_pct": number;
	"customer.ctg_uid": number;
	"customer.currency_type": string;
	"customer.cust_requestor_load_id": string;
	"customer.cust_stmt_template": number;
	"customer.d_and_b_code": string;
	"customer.d_and_b_date": Date;
	"customer.d_and_b_number": string;
	"customer.days_between_calls": number;
	"customer.deadhead_target": number;
	"customer.ded_last_fixed_cost_billdt": Date;
	"customer.dedicated_cycle": string;
	"customer.dedicated_revenue_code_id": string;
	"customer.dedicated_seg_alloc_code": string;
	"customer.dedicated_start_day": string;
	"customer.dedicated_template": number;
	"customer.def_rate_confirm_temp": number;
	"customer.delivered_template": number;
	"customer.departure_date_at": string;
	"customer.disable_automatic_tracking": string;
	"customer.display_eta": string;
	"customer.display_ysplit_stops": string;
	"customer.distance_method": string;
	"customer.distance_profile": string;
	"customer.distance_source": string;
	"customer.distance_type": string;
	"customer.dot_number": string;
	"customer.driver_load": string;
	"customer.empty_distance_charge_id": string;
	"customer.empty_distance_rate": number;
	"customer.enable_notifications": string;
	"customer.enforce_dep_dates": string;
	"customer.entered_date": Date;
	"customer.excise_taxable": string;
	"customer.expected_close": Date;
	"customer.extend_rates": string;
	"customer.factor_percent": number;
	"customer.factor_receivables": string;
	"customer.factoring_id": string;
	"customer.fak_profile_id": string;
	"customer.fourkites_customer_id": string;
	"customer.fuel_amount": number;
	"customer.fuel_base_price": number;
	"customer.fuel_credit": string;
	"customer.fuel_method": string;
	"customer.fuel_percent": number;
	"customer.fuel_price_region": string;
	"customer.fuel_surcharge_id": string;
	"customer.fuel_surchg_enddt": Date;
	"customer.fuel_surchg_strtdt": Date;
	"customer.fuel_variance": number;
	"customer.global_detention": string;
	"customer.google_place_id": string;
	"customer.gp_exclude": string;
	"customer.gp_exported": Date;
	"customer.gp_imported": Date;
	"customer.grace_period": number;
	"customer.high_balance": number;
	"customer.high_balance_c": string;
	"customer.high_balance_d": Date;
	"customer.high_balance_n": number;
	"customer.high_balance_r": number;
	"customer.ic_company_id": string;
	"customer.id": string;
	"customer.include_by_date": string;
	"customer.include_empty_distance": string;
	"customer.include_fuel_surcharge": string;
	"customer.include_split_point": string;
	"customer.integration_type": string;
	"customer.invoice_processing_id": string;
	"customer.is_active": string;
	"customer.is_consignee": string;
	"customer.is_distribution_center": string;
	"customer.is_drop_yard": string;
	"customer.is_geocoded": string;
	"customer.is_intercompany": string;
	"customer.is_pallets_required": string;
	"customer.is_shipper": string;
	"customer.is_trailer_pool_required": string;
	"customer.jaguar_id": number;
	"customer.last_bill_date": Date;
	"customer.last_fin_charge_dt": Date;
	"customer.last_pay_date": Date;
	"customer.last_ship_date": Date;
	"customer.latitude": number;
	"customer.location_id": string;
	"customer.longitude": number;
	"customer.macropoint_requestor_id": string;
	"customer.main_phone": string;
	"customer.manual_exchange": string;
	"customer.mark_plan_id": string;
	"customer.max_pay_percent": number;
	"customer.misc_bill_template": number;
	"customer.monthly_order_goal": number;
	"customer.motor_carrier_id": string;
	"customer.name": string;
	"customer.next_call_date": Date;
	"customer.next_rec_call": Date;
	"customer.nxt_action_code_id": string;
	"customer.nxt_action_date": Date;
	"customer.operations_user": string;
	"customer.order_count": number;
	"customer.order_detail_at": string;
	"customer.order_start_date": Date;
	"customer.p44_profile_id": string;
	"customer.paid_loads": number;
	"customer.pay_days_date": Date;
	"customer.pay_days_orders": number;
	"customer.payee_id": string;
	"customer.pd0_alert": number;
	"customer.pd1_np_auto": string;
	"customer.pd1_sp_auto": string;
	"customer.pd1_sp_thresh": number;
	"customer.pd1_sp_thresh_c": string;
	"customer.pd1_sp_thresh_d": Date;
	"customer.pd1_sp_thresh_n": number;
	"customer.pd1_sp_thresh_r": number;
	"customer.pd2_np_auto": string;
	"customer.pd2_sp_auto": string;
	"customer.pd2_sp_thresh": number;
	"customer.pd2_sp_thresh_c": string;
	"customer.pd2_sp_thresh_d": Date;
	"customer.pd2_sp_thresh_n": number;
	"customer.pd2_sp_thresh_r": number;
	"customer.pd3_np_auto": string;
	"customer.pd3_sp_auto": string;
	"customer.pd3_sp_thresh": number;
	"customer.pd3_sp_thresh_c": string;
	"customer.pd3_sp_thresh_d": Date;
	"customer.pd3_sp_thresh_n": number;
	"customer.pd3_sp_thresh_r": number;
	"customer.pd4_np_auto": string;
	"customer.pd4_sp_auto": string;
	"customer.pd4_sp_thresh": number;
	"customer.pd4_sp_thresh_c": string;
	"customer.pd4_sp_thresh_d": Date;
	"customer.pd4_sp_thresh_n": number;
	"customer.pd4_sp_thresh_r": number;
	"customer.plc_uid": number;
	"customer.post_summary_dtl": string;
	"customer.potential": number;
	"customer.potential_c": string;
	"customer.potential_d": Date;
	"customer.potential_n": number;
	"customer.potential_r": number;
	"customer.prev_code": string;
	"customer.primary_agency": string;
	"customer.primary_commodity_id": string;
	"customer.primary_contact": string;
	"customer.primary_sort": string;
	"customer.primary_trailer_type": string;
	"customer.print_containers": string;
	"customer.progress_template": number;
	"customer.prospect_type_id": string;
	"customer.quebec_number": string;
	"customer.quote_days_to_expire": number;
	"customer.rate_override_nmfc_code": string;
	"customer.reassign_profile_id": string;
	"customer.rec_call_days": number;
	"customer.remarks": string;
	"customer.require_tracking": string;
	"customer.required_vendor": string;
	"customer.revenue": number;
	"customer.revenue_c": string;
	"customer.revenue_d": Date;
	"customer.revenue_n": number;
	"customer.revenue_r": number;
	"customer.revenue_start_date": Date;
	"customer.routing_guide_profile_id": string;
	"customer.sales_manager_id": string;
	"customer.sales_status_id": string;
	"customer.salesperson_id": string;
	"customer.search_city": string;
	"customer.search_state_id": string;
	"customer.search_zip_code": string;
	"customer.secondary_sort": string;
	"customer.sell_tariff_id": string;
	"customer.service_fail_cons": string;
	"customer.service_fail_drop": string;
	"customer.service_fail_pick": string;
	"customer.service_fail_ship": string;
	"customer.service_failures": string;
	"customer.service_failures_review": string;
	"customer.shipment_ident_type": string;
	"customer.sic_code": string;
	"customer.smc3_profile_id": string;
	"customer.start_date": Date;
	"customer.state_id": string;
	"customer.summary_billing": string;
	"customer.summary_template": number;
	"customer.tar_uid": number;
	"customer.target_profit": number;
	"customer.tenfour_customer_id": string;
	"customer.tracking_hours_prior": number;
	"customer.trimble_place_id": string;
	"customer.type_of": string;
	"customer.use_local_mile": string;
	"customer.vm_part_update": string;
	"customer.waterfall_auto_route_guides": string;
	"customer.waterfall_lead_time": number;
	"customer.waterfall_notify_email": string;
	"customer.waterfall_process": string;
	"customer.website_url": string;
	"customer.wf_auto_renbill": string;
	"customer.wf_autobill": string;
	"customer.wf_bwop": string;
	"customer.wf_queue": number;
	"customer.zip_code": string;
	"customer.zone_id": string;
	"dest_city.airport_code": string;
	"dest_city.alk_id": number;
	"dest_city.central_location": string;
	"dest_city.company_id": string;
	"dest_city.county": string;
	"dest_city.id": number;
	"dest_city.inactive": string;
	"dest_city.isi_id": number;
	"dest_city.latitude": number;
	"dest_city.longitude": number;
	"dest_city.name": string;
	"dest_city.pcm_window_city_id": number;
	"dest_city.rmm_id": number;
	"dest_city.state_id": string;
	"dest_city.three_digit_zip": string;
	"dest_city.timezone_id": string;
	"dest_city.zip_code": string;
	"dest_city.zone_id": string;
	dest_same_day_window: boolean;
	destination_timezone: string;
	disable_electronic_offers: boolean;
	distance_pickup: number;
	id: string;
	is_hazmat: string;
	loaded: string;
	manifest_commodities: string;
	manifest_equipment: string;
	manifest_hold: string;
	max_buy: number;
	max_pay_calc: number;
	move_distance: number;
	"movement_order.company_id": string;
	"movement_order.id": string;
	"movement_order.movement_id": string;
	"movement_order.on_at_move_dest": string;
	"movement_order.on_at_move_origin": string;
	"movement_order.order_id": string;
	"movement_order.planned_manifest_id": string;
	"movement_order.sequence": number;
	"orders.actual_reefer_profile": string;
	"orders.agency_id": string;
	"orders.agent_payee_id": string;
	"orders.all_vendors_enabled": string;
	"orders.allow_relay": string;
	"orders.autorate_status": string;
	"orders.bill_date": Date;
	"orders.bill_distance": number;
	"orders.bill_distance_um": string;
	"orders.billing_empty_distance": number;
	"orders.billing_empty_distance_um": string;
	"orders.billing_loaded_distance": number;
	"orders.billing_loaded_distance_um": string;
	"orders.billing_user_id": string;
	"orders.blnum": string;
	"orders.bol_note": string;
	"orders.bol_received": string;
	"orders.bol_recv_date": Date;
	"orders.booking_no": string;
	"orders.booking_number": string;
	"orders.brk_qual_profile": string;
	"orders.broker_location_id": string;
	"orders.brokerage_workflow_id": string;
	"orders.carrier_scorecard_export_dt": Date;
	"orders.carrier_scorecard_exported": string;
	"orders.cbp_crossing_date": Date;
	"orders.cbp_crossing_location_id": string;
	"orders.cbp_crossing_reason": string;
	"orders.cbsa_crossing_date": Date;
	"orders.cbsa_crossing_location_id": string;
	"orders.cbsa_crossing_reason": string;
	"orders.cc_fuel_revenue": number;
	"orders.cc_fuel_revenue_c": string;
	"orders.cc_fuel_revenue_d": Date;
	"orders.cc_fuel_revenue_n": number;
	"orders.cc_fuel_revenue_r": number;
	"orders.cc_net_revenue": number;
	"orders.cc_net_revenue_c": string;
	"orders.cc_net_revenue_d": Date;
	"orders.cc_net_revenue_n": number;
	"orders.cc_net_revenue_r": number;
	"orders.cc_pro_nbr": string;
	"orders.cobroker_location_id": string;
	"orders.collection_method": string;
	"orders.com_setpnt_temp": number;
	"orders.com_setpnt_temp_dt": Date;
	"orders.com_setpnt_temp_um": string;
	"orders.commitment_id": string;
	"orders.commodity": string;
	"orders.commodity_id": string;
	"orders.company_id": string;
	"orders.consignee_refno": string;
	"orders.consignee_stop_id": string;
	"orders.container": string;
	"orders.container_planned": string;
	"orders.container_type_id": string;
	"orders.controlling_carrier_code": string;
	"orders.copy_from_company": string;
	"orders.copy_from_order_id": string;
	"orders.copy_to_company": string;
	"orders.copy_to_order_id": string;
	"orders.ctrl_party_id": string;
	"orders.cube": number;
	"orders.curr_movement_id": string;
	"orders.cust_order_no": string;
	"orders.customer_id": string;
	"orders.declared_val": number;
	"orders.def_move_type": string;
	"orders.default_match_id": string;
	"orders.dim_height": string;
	"orders.dim_length": string;
	"orders.dim_surcharge": number;
	"orders.dim_surcharge_c": string;
	"orders.dim_surcharge_d": Date;
	"orders.dim_surcharge_n": number;
	"orders.dim_surcharge_r": number;
	"orders.dim_width": string;
	"orders.dispatch_opt": string;
	"orders.dl_team_reqd": string;
	"orders.dray_del_date": Date;
	"orders.dray_del_pay": number;
	"orders.dray_del_pay_c": string;
	"orders.dray_del_pay_d": Date;
	"orders.dray_del_pay_n": number;
	"orders.dray_del_pay_r": number;
	"orders.dray_del_payee": string;
	"orders.dray_del_xfer_dt": Date;
	"orders.dray_pu_date": Date;
	"orders.dray_pu_pay": number;
	"orders.dray_pu_pay_c": string;
	"orders.dray_pu_pay_d": Date;
	"orders.dray_pu_pay_n": number;
	"orders.dray_pu_pay_r": number;
	"orders.dray_pu_payee": string;
	"orders.dray_pu_xfer_dt": Date;
	"orders.eir1_no": string;
	"orders.eir2_no": string;
	"orders.entered_user_id": string;
	"orders.equipment_type_id": string;
	"orders.equipment_type_options": string;
	"orders.est_tolls": number;
	"orders.est_tolls_c": string;
	"orders.est_tolls_d": Date;
	"orders.est_tolls_n": number;
	"orders.est_tolls_r": number;
	"orders.excise_disable_update": string;
	"orders.excise_taxable": string;
	"orders.excisetax_total": number;
	"orders.excisetax_total_c": string;
	"orders.excisetax_total_d": Date;
	"orders.excisetax_total_n": number;
	"orders.excisetax_total_r": number;
	"orders.external_invoiceno": string;
	"orders.extra_deliveries": number;
	"orders.extra_pickups": number;
	"orders.floor_loaded_freight": string;
	"orders.force_assign": string;
	"orders.forwd_location_id": string;
	"orders.free_days": number;
	"orders.freight_charge": number;
	"orders.freight_charge_c": string;
	"orders.freight_charge_d": Date;
	"orders.freight_charge_n": number;
	"orders.freight_charge_r": number;
	"orders.hazmat": string;
	"orders.hazmat_code": string;
	"orders.high_value": string;
	"orders.hold_reason": string;
	"orders.ic_company_from": string;
	"orders.ic_movement_from": string;
	"orders.ic_order_from": string;
	"orders.id": string;
	"orders.image_is_present": string;
	"orders.import_export": string;
	"orders.include_split_point": string;
	"orders.intelliset": string;
	"orders.invoice_recv_date": Date;
	"orders.is_auto_tonu": string;
	"orders.is_autorate_dist": string;
	"orders.is_container": string;
	"orders.is_dedicated": string;
	"orders.is_intercompany": string;
	"orders.is_local_mile": string;
	"orders.is_requested": string;
	"orders.is_tonu": string;
	"orders.jag_carrier_id": string;
	"orders.jag_cost_rate_id": number;
	"orders.ldport_location_id": string;
	"orders.linear_feet_avail": number;
	"orders.load_date": Date;
	"orders.loadboard": string;
	"orders.loadboard_post_movement_id": string;
	"orders.loadboard_posting_cancelled": string;
	"orders.lock_miles": string;
	"orders.ltl": string;
	"orders.markup_flat": number;
	"orders.markup_flat_c": string;
	"orders.markup_flat_d": Date;
	"orders.markup_flat_n": number;
	"orders.markup_flat_r": number;
	"orders.markup_percent": number;
	"orders.master_order_id": string;
	"orders.master_sequence": number;
	"orders.next_rebill": string;
	"orders.nte_lp_num": string;
	"orders.nte_lp_qual": string;
	"orders.on_hold": string;
	"orders.operational_status": string;
	"orders.operations_user": string;
	"orders.optimize": string;
	"orders.optiset": string;
	"orders.order_length": number;
	"orders.order_mode": string;
	"orders.order_type_id": string;
	"orders.order_value": number;
	"orders.order_value_c": string;
	"orders.order_value_d": Date;
	"orders.order_value_n": number;
	"orders.order_value_r": number;
	"orders.ordered_by": string;
	"orders.ordered_by_id": string;
	"orders.ordered_date": Date;
	"orders.ordered_method": string;
	"orders.orig_dest_rate_id": string;
	"orders.otherchargetotal": number;
	"orders.otherchargetotal_c": string;
	"orders.otherchargetotal_d": Date;
	"orders.otherchargetotal_n": number;
	"orders.otherchargetotal_r": number;
	"orders.override_arrive_early": Date;
	"orders.override_arrive_late": Date;
	"orders.override_posting_city_id": number;
	"orders.pallets_how_many": number;
	"orders.pallets_required": string;
	"orders.pay_gross": number;
	"orders.pay_gross_c": string;
	"orders.pay_gross_d": Date;
	"orders.pay_gross_n": number;
	"orders.pay_gross_r": number;
	"orders.pick_up_no": string;
	"orders.pieces": number;
	"orders.placard_required": string;
	"orders.planning_comment": string;
	"orders.pnn_callback": string;
	"orders.pnn_comment": string;
	"orders.pnn_comment2": string;
	"orders.pnn_loadboard_user_id": string;
	"orders.pnn_post_type": string;
	"orders.pnn_rate": number;
	"orders.pnn_rate_type": string;
	"orders.pnn_trailer_length": number;
	"orders.pnn_trailer_width": number;
	"orders.ponum": string;
	"orders.port": string;
	"orders.port_of_discharge": string;
	"orders.preferred_vendors": string;
	"orders.preload_trailer_id": string;
	"orders.preloaded": string;
	"orders.rate": number;
	"orders.rate_currency_type": string;
	"orders.rate_id": number;
	"orders.rate_min_weight": number;
	"orders.rate_min_weight_um": string;
	"orders.rate_source": string;
	"orders.rate_type": string;
	"orders.rate_unit_desc": string;
	"orders.rate_units": number;
	"orders.ready_to_bill": string;
	"orders.recurring_order_id": string;
	"orders.reply_transmitted": string;
	"orders.requesting_company": string;
	"orders.return_temp": number;
	"orders.return_temp_dt": Date;
	"orders.return_temp_um": string;
	"orders.return_temp_var": number;
	"orders.return_temp_var_um": string;
	"orders.revenue_code_id": string;
	"orders.revenue_share_method": string;
	"orders.round_trip": string;
	"orders.sail_date": Date;
	"orders.seal_number": string;
	"orders.seg_alloc_code": string;
	"orders.setpoint_temp": number;
	"orders.setpoint_temp_um": string;
	"orders.setpoint_var": number;
	"orders.setpoint_var_um": string;
	"orders.ship_status_to_edi": string;
	"orders.shipment_id": string;
	"orders.shipper_stop_id": string;
	"orders.shipstatus2edi_dt": Date;
	"orders.ss_location_id": string;
	"orders.status": string;
	"orders.subject_order_number": string;
	"orders.subject_order_status": string;
	"orders.subject_order_void_date": Date;
	"orders.swap": string;
	"orders.teams_required": string;
	"orders.temperature_max": number;
	"orders.temperature_max_um": string;
	"orders.temperature_min": number;
	"orders.temperature_min_um": string;
	"orders.temperature_um": string;
	"orders.total_charge": number;
	"orders.total_charge_c": string;
	"orders.total_charge_d": Date;
	"orders.total_charge_n": number;
	"orders.total_charge_r": number;
	"orders.totalcharge_and_excisetax": number;
	"orders.totalcharge_and_excisetax_c": string;
	"orders.totalcharge_and_excisetax_d": Date;
	"orders.totalcharge_and_excisetax_n": number;
	"orders.totalcharge_and_excisetax_r": number;
	"orders.tractor_type": string;
	"orders.vessel": string;
	"orders.vessel_cutoff_date": Date;
	"orders.voided_load_transmitted": string;
	"orders.voided_load_transmitted_dt": Date;
	"orders.weight": number;
	"orders.weight_um": string;
	"orders.xferred2billing": string;
	"orders.xferred2billing_dt": Date;
	"origin_city.airport_code": string;
	"origin_city.alk_id": number;
	"origin_city.central_location": string;
	"origin_city.company_id": string;
	"origin_city.county": string;
	"origin_city.id": number;
	"origin_city.inactive": string;
	"origin_city.isi_id": number;
	"origin_city.latitude": number;
	"origin_city.longitude": number;
	"origin_city.name": string;
	"origin_city.pcm_window_city_id": number;
	"origin_city.rmm_id": number;
	"origin_city.state_id": string;
	"origin_city.three_digit_zip": string;
	"origin_city.timezone_id": string;
	"origin_city.zip_code": string;
	"origin_city.zone_id": string;
	origin_same_day_window: boolean;
	origin_timezone: string;
	override_max_pay: number;
	override_pay_amt: number;
	override_payee_id: string;
	override_targetpay: number;
	status: string;
	"stop_dest.actual_arrival": Date;
	"stop_dest.actual_departure": Date;
	"stop_dest.address": string;
	"stop_dest.address2": string;
	"stop_dest.appointment_status_id": string;
	"stop_dest.appt_contact_name": string;
	"stop_dest.appt_required": string;
	"stop_dest.cases": number;
	"stop_dest.city_id": number;
	"stop_dest.city_name": string;
	"stop_dest.company_id": string;
	"stop_dest.confirmed": string;
	"stop_dest.contact_email": string;
	"stop_dest.contact_name": string;
	"stop_dest.dist_from_prev": number;
	"stop_dest.dist_from_prev_um": string;
	"stop_dest.driver_load_unload": string;
	"stop_dest.edi_code": string;
	"stop_dest.edi_loc_code": string;
	"stop_dest.eta": Date;
	"stop_dest.eta_distance": number;
	"stop_dest.eta_late": string;
	"stop_dest.eta_oor": string;
	"stop_dest.google_place_id": string;
	"stop_dest.grouped_id": number;
	"stop_dest.hub": number;
	"stop_dest.ic_stop_id": string;
	"stop_dest.id": string;
	"stop_dest.inbound_status": string;
	"stop_dest.late_eta_colorcode": string;
	"stop_dest.late_route_status": string;
	"stop_dest.latitude": number;
	"stop_dest.location_id": string;
	"stop_dest.location_name": string;
	"stop_dest.longitude": number;
	"stop_dest.manifest_fgp_uid": number;
	"stop_dest.manifest_reg_uid": number;
	"stop_dest.move_dist_from_preassign": number;
	"stop_dest.move_dist_from_preassign_um": string;
	"stop_dest.move_dist_from_previous": number;
	"stop_dest.move_dist_from_previous_um": string;
	"stop_dest.movement_id": string;
	"stop_dest.movement_sequence": number;
	"stop_dest.operational_status": string;
	"stop_dest.order_id": string;
	"stop_dest.order_sequence": number;
	"stop_dest.orig_sched_early": Date;
	"stop_dest.orig_sched_late": Date;
	"stop_dest.pallets_dropped": number;
	"stop_dest.pallets_picked_up": number;
	"stop_dest.payment_code_reviewed": string;
	"stop_dest.phone": string;
	"stop_dest.planned_arrival_time": Date;
	"stop_dest.ponum": string;
	"stop_dest.prior_uncleared_stops": string;
	"stop_dest.projected_arrival": Date;
	"stop_dest.pu_override_arrive_early": Date;
	"stop_dest.pu_override_arrive_late": Date;
	"stop_dest.rate_dist_from_previous": number;
	"stop_dest.rate_dist_from_previous_um": string;
	"stop_dest.refno": string;
	"stop_dest.requested_service": string;
	"stop_dest.sched_arrive_early": Date;
	"stop_dest.sched_arrive_late": Date;
	"stop_dest.seal": string;
	"stop_dest.service_date": Date;
	"stop_dest.showas_address": string;
	"stop_dest.showas_address2": string;
	"stop_dest.showas_city_id": number;
	"stop_dest.showas_city_name": string;
	"stop_dest.showas_location_id": string;
	"stop_dest.showas_location_name": string;
	"stop_dest.showas_state": string;
	"stop_dest.showas_zip_code": string;
	"stop_dest.signed_for_name": string;
	"stop_dest.state": string;
	"stop_dest.status": string;
	"stop_dest.stop_type": string;
	"stop_dest.trimble_place_id": string;
	"stop_dest.txl_uid": number;
	"stop_dest.volume": number;
	"stop_dest.volume_um": string;
	"stop_dest.weight": number;
	"stop_dest.weight_um": string;
	"stop_dest.zip_code": string;
	"stop_dest.zone_id": string;
	"stop_origin.actual_arrival": Date;
	"stop_origin.actual_departure": Date;
	"stop_origin.address": string;
	"stop_origin.address2": string;
	"stop_origin.appointment_status_id": string;
	"stop_origin.appt_contact_name": string;
	"stop_origin.appt_required": string;
	"stop_origin.cases": number;
	"stop_origin.city_id": number;
	"stop_origin.city_name": string;
	"stop_origin.company_id": string;
	"stop_origin.confirmed": string;
	"stop_origin.contact_email": string;
	"stop_origin.contact_name": string;
	"stop_origin.dist_from_prev": number;
	"stop_origin.dist_from_prev_um": string;
	"stop_origin.driver_load_unload": string;
	"stop_origin.edi_code": string;
	"stop_origin.edi_loc_code": string;
	"stop_origin.eta": Date;
	"stop_origin.eta_distance": number;
	"stop_origin.eta_late": string;
	"stop_origin.eta_oor": string;
	"stop_origin.google_place_id": string;
	"stop_origin.grouped_id": number;
	"stop_origin.hub": number;
	"stop_origin.ic_stop_id": string;
	"stop_origin.id": string;
	"stop_origin.inbound_status": string;
	"stop_origin.late_eta_colorcode": string;
	"stop_origin.late_route_status": string;
	"stop_origin.latitude": number;
	"stop_origin.location_id": string;
	"stop_origin.location_name": string;
	"stop_origin.longitude": number;
	"stop_origin.manifest_fgp_uid": number;
	"stop_origin.manifest_reg_uid": number;
	"stop_origin.move_dist_from_preassign": number;
	"stop_origin.move_dist_from_preassign_um": string;
	"stop_origin.move_dist_from_previous": number;
	"stop_origin.move_dist_from_previous_um": string;
	"stop_origin.movement_id": string;
	"stop_origin.movement_sequence": number;
	"stop_origin.operational_status": string;
	"stop_origin.order_id": string;
	"stop_origin.order_sequence": number;
	"stop_origin.orig_sched_early": Date;
	"stop_origin.orig_sched_late": Date;
	"stop_origin.pallets_dropped": number;
	"stop_origin.pallets_picked_up": number;
	"stop_origin.payment_code_reviewed": string;
	"stop_origin.phone": string;
	"stop_origin.planned_arrival_time": Date;
	"stop_origin.ponum": string;
	"stop_origin.prior_uncleared_stops": string;
	"stop_origin.projected_arrival": Date;
	"stop_origin.pu_override_arrive_early": Date;
	"stop_origin.pu_override_arrive_late": Date;
	"stop_origin.rate_dist_from_previous": number;
	"stop_origin.rate_dist_from_previous_um": string;
	"stop_origin.refno": string;
	"stop_origin.requested_service": string;
	"stop_origin.sched_arrive_early": Date;
	"stop_origin.sched_arrive_late": Date;
	"stop_origin.seal": string;
	"stop_origin.service_date": Date;
	"stop_origin.showas_address": string;
	"stop_origin.showas_address2": string;
	"stop_origin.showas_city_id": number;
	"stop_origin.showas_city_name": string;
	"stop_origin.showas_location_id": string;
	"stop_origin.showas_location_name": string;
	"stop_origin.showas_state": string;
	"stop_origin.showas_zip_code": string;
	"stop_origin.signed_for_name": string;
	"stop_origin.state": string;
	"stop_origin.status": string;
	"stop_origin.stop_type": string;
	"stop_origin.trimble_place_id": string;
	"stop_origin.txl_uid": number;
	"stop_origin.volume": number;
	"stop_origin.volume_um": string;
	"stop_origin.weight": number;
	"stop_origin.weight_um": string;
	"stop_origin.zip_code": string;
	"stop_origin.zone_id": string;
	stops_pick_drop: string;
	target_pay: number;
	target_pay_calc: number;
	target_pay_method: string;
	weight: string;
	carrier_id: string;
	cutoff_date: Date;
	load_to_city_id: number;
	load_to_radius: number;
	location_city_id: number;
	location_radius: number;
	max_loads: number;
	trailer_type: string;
}

